import React from "react";
import styles from "./EmptyImage.module.css";

export const EmptyImage: React.FC = () => {
    return ( 
        <svg className={styles.EmptyImage} viewBox={'0 0 335 335'}>
            <path fill="currentColor" fillOpacity="0.25" d="M0 0h335v335H0z"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M263.859 188.438 201 83.75l-29.558 49.226c-9.996-6.419-21.888-10.143-34.65-10.143-35.462 0-64.209 28.747-64.209 64.209 0 35.461 28.747 64.208 64.209 64.208 34.994 0 63.451-27.996 64.193-62.812h62.874zm-125.718 0h62.844c.01-.465.015-.93.015-1.396 0-22.699-11.779-42.647-29.558-54.066l-33.301 55.462z"
                  fill="currentColor"/>
        </svg>
    )
}